import {
  ApplicationRef,
  createComponent,
  EmbeddedViewRef,
  EnvironmentInjector,
  Injectable,
} from '@angular/core';

@Injectable()
export class AppendCompService {
  constructor(
    private _appRef: ApplicationRef,
    private _injector: EnvironmentInjector,
  ) {}

  appendComponentToBody(component: any) {
    const componentRef = createComponent(component, {
      environmentInjector: this._injector,
    });
    this._appRef.attachView(componentRef.hostView);
    const domElem = (componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
    document.body.appendChild(domElem);
  }
}
